import { NumberInput, Switch, TextInput } from '@mantine/core';

import type { UseFormReturnType } from '@mantine/form';

type Props<T> = {
  form: UseFormReturnType<T, (values: T) => T>;
  showBlockchain: boolean;
  useBlockchain: boolean;
};

export function PaymentVerificationFormFields<T>(props: Props<T>) {
  const {
    form,
    showBlockchain,
    useBlockchain,
  } = props;

  return (
    <>
      {showBlockchain && (
        <>
          <Switch
            mt={10}
            label="Автоматическая проверка USDT в TRON (TRC20)"
            description="Выключено — хеш проверяет оператор. Настройка действует на новые заявки."
            key={form.key('useBlockchain')}
            {...form.getInputProps('useBlockchain', { type: 'checkbox' })}
          />
          {useBlockchain && (
            <>
              <TextInput
                label="Название поля реквизитов с адресом кошелька"
                key={form.key('data.blockchain.addressField')}
                {...form.getInputProps('data.blockchain.addressField')}
              />
              <NumberInput
                label="Количество подтверждений"
                min={1}
                max={1000}
                allowDecimal={false}
                key={form.key('data.blockchain.requiredConfirmations')}
                {...form.getInputProps('data.blockchain.requiredConfirmations')}
              />
            </>
          )}
        </>
      )}

      <Switch
        mt={10}
        label="Использовать уникализацию суммы"
        description="Сумма к оплате будет отличаться на выбранный шаг. Зачисляется исходная сумма заказа."
        key={form.key('useUniqueAmount')}
        {...form.getInputProps('useUniqueAmount', { type: 'checkbox' })}
      />
      <NumberInput
        label="Шаг уникализации"
        description="Обычно 0,01. Для платёжек с целыми суммами укажите 1."
        min={0.0000000001}
        decimalScale={10}
        step={0.01}
        key={form.key('uniqueAmountStep')}
        {...form.getInputProps('uniqueAmountStep')}
      />
    </>
  );
}
